const DEFAULT_BRAND_NAME = 'Our Marketplace';
const DEFAULT_BASE_URL = 'https://etsy-killer.fly.dev';

export const BRAND_NAME: string = import.meta.env.VITE_BRAND_NAME?.trim() || DEFAULT_BRAND_NAME;
export const BASE_URL: string = (import.meta.env.VITE_PUBLIC_BASE_URL?.trim() || DEFAULT_BASE_URL).replace(/\/+$/, '');

export function formatMoney(cents: number, currency = 'USD'): string {
  const amount = (cents ?? 0) / 100;
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD',
    }).format(amount);
  } catch {
    return `$${amount.toFixed(2)}`;
  }
}
